import { render } from "./TheAdminPurchaseAuthorizationShow.vue?vue&type=template&id=6e828ea2&scoped=true&ts=true"
import script from "./TheAdminPurchaseAuthorizationShow.vue?vue&type=script&lang=ts"
export * from "./TheAdminPurchaseAuthorizationShow.vue?vue&type=script&lang=ts"

import "./TheAdminPurchaseAuthorizationShow.vue?vue&type=style&index=0&id=6e828ea2&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e828ea2"]])

export default __exports__